// GENERATED by scripts/build-icons.mjs from icons/user-round.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const UserRound = createIcon('user-round', [
  ['circle', { cx: "12", cy: "8", r: "5" }],
  ['path', { d: "M20 21a8 8 0 0 0-16 0" }],
])
